
{
  "userMenu": {
    "profile": "Profile",
    "myListings": "My Listings",
    "myFavorites": "My Favorites",
    "referFriend": "Refer a Friend"
  },
  "profile": {
    "title": "Profile Settings",
    "personalInfo": "Personal Information",
    "accountSettings": "Account Settings",
    "referral": {
      "title": "Refer Friends",
      "description": "Share your referral link and earn rewards when friends sign up",
      "copy": "Copy Link",
      "copiedSuccess": "Referral link copied!",
      "copiedDescription": "Share this link with your friends",
      "referViaWhatsapp": "Refer via WhatsApp"
    }
  },
  "listings": {
    "title": "My Listings",
    "empty": {
      "title": "No listings yet",
      "description": "Create your first listing to start building your provider presence",
      "cta": "Create Listing"
    },
    "status": {
      "pending": "Pending Review",
      "approved": "Active",
      "rejected": "Rejected"
    }
  },
  "favorites": {
    "title": "My Favorites",
    "empty": {
      "title": "No favorites yet",
      "description": "Save service providers you're interested in",
      "cta": "Browse Services"
    }
  },
  "analytics": {
    "title": "Listing analytics",
    "views": "Views",
    "contacts": "Contacts",
    "performance": "Performance"
  }
}
